var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mobile
        ? [
            _c("summary-value", {
              staticClass: "py-3 px-4",
              attrs: { small: _vm.small, "no-description": "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n                LPP™ " +
                            _vm._s(_vm.chosen) +
                            "\n            "
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "value",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.getLppLabel(_vm.client.lpp_type)) +
                            "\n            "
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "description",
                    fn: function() {
                      return [
                        _vm.checkNested(
                          _vm.benefits,
                          "selectedLpp",
                          "description"
                        )
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    color: "grey lighten-1",
                                                    small: ""
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n                            $mdiInformation\n                        "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2083845861
                                )
                              },
                              [
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.benefits.selectedLpp.description
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                89905146
              )
            }),
            _vm._v(" "),
            _c("v-divider"),
            _vm._v(" "),
            _c("summary-value", {
              staticClass: "py-3 px-4",
              attrs: {
                object: _vm.benefits,
                property: "lppMonthlyPremium",
                small: _vm.small
              }
            })
          ]
        : [
            _vm._l(_vm.properties_object, function(property, index) {
              return [
                index !== 0
                  ? _c("v-divider", { staticClass: "mx-4" })
                  : _vm._e(),
                _vm._v(" "),
                _c("summary-breakdown", {
                  key: "property-" + index,
                  staticClass: "py-3 px-4",
                  attrs: {
                    object: _vm.benefits,
                    property: property,
                    small: _vm.small
                  }
                })
              ]
            }),
            _vm._v(" "),
            _c("v-divider", { staticClass: "mx-4" }),
            _vm._v(" "),
            _c("summary-value", {
              staticClass: "py-3 px-4",
              attrs: { small: _vm.small, "no-description": "" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n                LPP™ " +
                          _vm._s(_vm.chosen) +
                          "\n            "
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "value",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.getLppLabel(_vm.client.lpp_type)) +
                          "\n            "
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "description",
                  fn: function() {
                    return [
                      _vm.checkNested(
                        _vm.benefits,
                        "selectedLpp",
                        "description"
                      )
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  color: "grey lighten-1",
                                                  small: ""
                                                }
                                              },
                                              "v-icon",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              "\n                            $mdiInformation\n                        "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2083845861
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.benefits.selectedLpp.description
                                  )
                                }
                              })
                            ]
                          )
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("v-divider"),
            _vm._v(" "),
            _vm._l(_vm.properties, function(property, index) {
              return [
                _c("summary-value", {
                  key: index,
                  staticClass: "py-3 px-4",
                  attrs: {
                    object: _vm.benefits,
                    property: property,
                    small: _vm.small,
                    greyed: _vm.isGreyed(property),
                    inverted: _vm.isInverted(property)
                  }
                }),
                _vm._v(" "),
                _c("v-divider")
              ]
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }